<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="ايون">
<h1><span dir="rtl">ايون</span></h1>
<p style="text-align:Center"><span dir="rtl">اسمها نورة.. يمكنك أن تدعوها "أيون".<br/>هي بشريَّةٌ أَحَبَّتْ كونها</span> <span dir="rtl">مُظلمة ومعتمة، وهذا ما جعلها جميلة.
</span></p>
<p style="text-align:Center; directon:rtl"><span>
أتُريد أن تعلم ما الذي يجعلها أفضل؟ لأنَّها تقبَّلَتِ اختلافها.لذا تريد أن تخُطَّ بعض الكلمات بسوادها، وتُعيرَك إيَّاها.



</span></p>
<br/><br/>
<p style="text-align:center; direction:ltr">The author's name is Noura but she likes to be called iON.</p>
<p style="text-align:center; direction:ltr">She is a human who loves being dark.</p>
<p style="text-align:center; direction:ltr">That's what makes her beautiful. And do you know what makes it better? That she has accepted who she is.</p>
<p style="text-align:center; direction:ltr">Now she wants to turn her gloom into words so you can borrow them.</p>
<br/>
<p style="text-align:center">******</p><br/>
<p><span dir="rtl">فتاة آمنَت دائمًا أنَّه كَون الشَّخص مُظلِمًا لا يعني بأنَّه لا يمتلك الأحقيَّة في التميُّز، وذلك بحدِّ ذاته ما ميَّزَها.</span></p><br/>
<p><span dir="rtl">لذا بدأَت في الكتابة لإخبار الجميع أنَّ الاختلاف لا يعني النهاية، بل بداية تاريخٍ آخَر.ثقَّفَت نفسها، وأبرَزَت حروفها.. رسمَت وأنجزَت، وها هي تبدأ مسيرتها.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?de3b7176